/* eslint-disable max-len */
// eslint-disable-next-line max-len
import {
  SET_PLA_CONFIGURATION, SET_PLA_CONFIGURATION_COLOR, USER_HAS_CHANGED_COLOR, SET_PLA_CONFIGURATION_DETAILS, SET_UPDATED_PLA_CONFIGURED_PRICE
} from '../actions/plaConfigurations';

const initialState = {
};

export default (state = initialState, action) => {
  switch (action.type) {
  case SET_PLA_CONFIGURATION: {
    return {
      ...state,
      ...action.payload,
    };
  }
  case SET_PLA_CONFIGURATION_DETAILS: {
    return {
      ...state,
      ...action.payload,
    };
  }
  case SET_PLA_CONFIGURATION_COLOR: {
    return {
      ...state,
      selectedColor: action.payload,
    };
  }
  case USER_HAS_CHANGED_COLOR: {
    return {
      ...state,
      ...action.payload,
    };
  }
  case SET_UPDATED_PLA_CONFIGURED_PRICE: {
    return {
      ...state,
      plaConfiguredPrice: action.payload.priceDetails,
    };
  }

  default:
    return state;
  }
};